module.exports = __webpack_public_path__ + "img/ViewEye.4b7b925f.svg";